import React from 'react';
import Icon from '../../../components/AppIcon';

const ResponseTimeMetrics = ({ metrics, loading }) => {
  if (loading) {
    return (
      <div className="glass-card p-6 rounded-2xl">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            <div className="h-20 bg-gray-100 rounded"></div>
            <div className="h-20 bg-gray-100 rounded"></div>
            <div className="h-20 bg-gray-100 rounded"></div>
          </div>
        </div>
      </div>
    );
  }

  const formatHours = (hours) => {
    if (hours === 0) return 'N/A';
    if (hours < 24) return `${Math.round(hours)}h`;
    const days = Math.floor(hours / 24);
    const remainingHours = Math.round(hours % 24);
    return `${days}j ${remainingHours}h`;
  };

  const timeMetrics = [
    {
      title: 'Temps de première réponse',
      icon: 'Clock',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      data: metrics?.responseTime,
      description: 'De la soumission à la première revue'
    },
    {
      title: 'Temps de programmation',
      icon: 'Calendar',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      data: metrics?.timeToSchedule,
      description: 'De la soumission au rendez-vous fixé'
    },
    {
      title: 'Temps de finalisation',
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      data: metrics?.timeToComplete,
      description: 'De la soumission à la finalisation'
    }
  ];

  return (
    <div className="glass-card p-6 rounded-2xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center">
          <Icon name="Activity" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Temps de réponse</h3>
          <p className="text-sm text-muted-foreground">{metrics?.totalProcessed || 0} cas traités</p>
        </div>
      </div>
      <div className="space-y-4">
        {timeMetrics?.map((metric, index) => (
          <div key={index} className="p-4 bg-gray-50 rounded-xl">
            <div className="flex items-center gap-3 mb-3">
              <div className={`w-8 h-8 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
                <Icon name={metric?.icon} size={16} className={metric?.color} />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-foreground">{metric?.title}</h4>
                <p className="text-xs text-muted-foreground">{metric?.description}</p>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-3">
              <div>
                <p className="text-xs text-muted-foreground mb-1">Moyenne</p>
                <p className="text-lg font-bold text-foreground">
                  {formatHours(metric?.data?.avg || 0)}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Médiane</p>
                <p className="text-lg font-bold text-foreground">
                  {formatHours(metric?.data?.median || 0)}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Min</p>
                <p className="text-lg font-bold text-success">
                  {formatHours(metric?.data?.min || 0)}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Max</p>
                <p className="text-lg font-bold text-error">
                  {formatHours(metric?.data?.max || 0)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResponseTimeMetrics;